import moment from "moment";
import React, { useEffect, useState } from "react";
import { Card, Col, Container, ListGroup, Row } from "react-bootstrap";
import { List } from "react-feather";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { blankFetchNotification, fetchNotification } from "../../redux/slices/CommonSlice";

const AllNotification = () => {
    const { index } = useParams();
    const dispatch = useDispatch();
    const notification = useSelector(state=>state.common.notification);
    const notificationStatus = useSelector(state=>state.common.status);
    const [notificationData,setNotificationData] = useState([]);

    useEffect(()=>{
        dispatch(blankFetchNotification());
    },[])
    useEffect(()=>{
        if(notificationStatus==="idle"){
            dispatch(fetchNotification("all"))
        }
    },[notificationStatus,dispatch])
    useEffect(()=>{
        if(notification && Object.keys(notification).length > 0){
            if(notification.error === 0){
                setNotificationData(notification.data.client_notifications);
            }
        }
    },[notification])
    return (
        <React.Fragment>
            <Helmet title='Credit Audit' />
            <Container fluid className='p-0 container-fluid-1335'>
                <Card>
                    <Card.Body>
                        <h3 className="mb-3">All Notifications</h3>
                        <ListGroup>
                            {notificationData && notificationData.length > 0 ?
                            <>
                                {notificationData.map((data,indexIn)=>{
                                    return (
                                        <ListGroup.Item className={`${indexIn == index?'border-2 border border-danger':''}`}>{data.notification_text}<br/><small>{moment(data.created_on).fromNow()}</small></ListGroup.Item>           
                                    )
                                })} 
                            </>
                            :<ListGroup.Item>No New Notification</ListGroup.Item>}
                        </ListGroup>
                    </Card.Body>
                </Card>
            </Container>
        </React.Fragment>
    );
}

export default AllNotification;